/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function DownloadIcon({ className, size = 'small' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17 17.5a.5.5 0 01-.5.5h-14a.5.5 0 010-1h14a.5.5 0 01.5.5zm-7.032-4.262l2.72-3.081a.451.451 0 01.664-.021.523.523 0 01.02.707l-3.53 4a.457.457 0 01-.343.157.456.456 0 01-.342-.157l-3.53-4a.524.524 0 01.021-.707.451.451 0 01.664.02l2.717 3.08V2.5c0-.276.21-.5.47-.5s.47.224.47.5v10.738z"
      ></path>
    </svg>
  );
}
